import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export const scorecardVisibilityKeys = {
  all: ['scorecard-visibility-settings'],
};

const getScorecardVisibilitySettings = async () => {
  const response = await http.get(`/ats_scorecards/settings`);
  return response;
};

const updateScorecardVisibilitySettings = async (payload) => {
  const response = await http.put(`/ats_scorecards/settings`, payload);
  return response;
};

export const API_SERVICE = {
  getScorecardVisibilitySettings,
  updateScorecardVisibilitySettings,
};

export const useScorecardVisibilitySettings = (options = {}) =>
  useQuery({
    queryKey: scorecardVisibilityKeys.all,
    queryFn: () => API_SERVICE.getScorecardVisibilitySettings(),
    staleTime: 0,
    ...options,
  });

export const useUpdateScorecardVisibilitySettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: API_SERVICE.updateScorecardVisibilitySettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: scorecardVisibilityKeys.all });
    },
  });
};
